export function useCachedData(key: string) {
  const nuxtApp = useNuxtApp()

  const data = nuxtApp.payload.data[key] || nuxtApp.static.data[key]
  const expirationTimestamp = parseInt(data?.fetchedAt + 1000 * 60 * 60)
  const isExpired = expirationTimestamp < useUnixTimestamp()
  if (!data || isExpired) return

  return data
}
